import EDC from '@/components/games/shared/globals';
import CursorManager from '@/components/games/shared/cursor-manager';
import router from '@/router';
/**
 *
 */
EDC.Games.WelcomePage.Scenes.Main = function () {};

const welcomePage = EDC.Games.WelcomePage.Scenes.Main.prototype;

welcomePage.init = function () {
  this.bg = null;
  this.content = null;
  this.cursorManager = null;
  this.logo = null;
  this.scale.off('resize', this.resize, this);
};

welcomePage.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);

  this.bg = this.add.image(this.scale.width / 2, this.scale.height / 2, 'background');
  this.content = this.add.container();

  const title = this.add
    .image(0, 210, 'title')
    .setOrigin(0)
    .setScale(0.9);
  this.logo = this.add.image(0, 0, 'logo').setScale(0.9);
  this.logo.init_scale = 0.9;
  const text = this.add.image(this.scale.width / 2 - 70, 680, 'text');

  const nevermindBtn = this.add.image(0, 0, 'nevermind_btn');
  const nevermindArr = this.add.image(-215, 0, 'nevermind_arr');
  const nevermindContainer = this.add.container(240, 980,
    [nevermindBtn, nevermindArr]).setSize(613, 131);

  const continueBtn = this.add.image(0, 0, 'continue_btn');
  const continueArr = this.add.image(215, 0, 'continue_arr');
  const continueContainer = this.add.container(1060, 980,
    [continueBtn, continueArr]).setSize(613, 131);

  // const btnHitArea = new Phaser.Geom.Rectangle(-306, -65, 613, 131);
  nevermindContainer.setInteractive();
  continueContainer.setInteractive();

  nevermindContainer.on('pointerdown', this.onNevermindClick);
  continueContainer.on('pointerdown', this.onContinueClick);

  this.cursorManager.setDefaultDraggableEvents(nevermindContainer);
  this.cursorManager.setDefaultDraggableEvents(continueContainer);

  this.content.add([title, text, nevermindContainer, continueContainer]);

  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });
};
/**
 *
 */
welcomePage.onNevermindClick = function () {
  router.push({ name: 'main-menu' });
};
/**
 *
 */
welcomePage.onContinueClick = function () {
  router.push({ name: 'newgame' });
};

welcomePage.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;
  this.cameras.resize(width, height);
  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);
  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.8) / contentWidth;
  const scaleY = (height * 0.8) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition(
    (width - bounds.width) / 2 + 150 * neededScale,
    height / 2 - bounds.height + 160 * neededScale,
  );

  this.logo.setScale(this.logo.init_scale * neededScale);
  this.logo.setPosition(this.content.x + bounds.width / 2 - 865 * neededScale,
    this.content.y + 330 * neededScale);
};

export default EDC.Games.WelcomePage.Scenes.Main;
